import { ChevronDown, ChevronUp, SlidersHorizontal } from 'lucide-react'
import { useState } from 'react'

import {
  CampoFiltro,
  ChipFiltro,
  estiloInputFiltro,
} from '../FiltrosPosComunes'

// Filtros globales de Analítica POS. Mobile (sección 72): solo Período +
// "Más filtros" visibles de entrada; el resto queda colapsado.
function AnaliticaFiltros({
  filtros,
  onCambiarFiltro,
  onAplicarRango,
  rangosRapidos,
  clientes,
  productos,
  usuarios,
  tiposEnvase,
  onLimpiar,
  hayFiltrosAvanzadosActivos,
}) {
  const [masFiltros, setMasFiltros] = useState(false)

  return (
    <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <CampoFiltro label="Fecha desde">
          <input
            type="date"
            value={filtros.fechaDesde}
            onChange={(event) => onCambiarFiltro('fechaDesde', event.target.value)}
            className={estiloInputFiltro}
          />
        </CampoFiltro>

        <CampoFiltro label="Fecha hasta">
          <input
            type="date"
            value={filtros.fechaHasta}
            onChange={(event) => onCambiarFiltro('fechaHasta', event.target.value)}
            className={estiloInputFiltro}
          />
        </CampoFiltro>

        <CampoFiltro label="Estado de pago">
          <select
            value={filtros.estadoPago}
            onChange={(event) => onCambiarFiltro('estadoPago', event.target.value)}
            className={estiloInputFiltro}
          >
            <option value="">Todos</option>
            <option value="pendiente">Pendiente</option>
            <option value="parcial">Parcial</option>
            <option value="pagado">Pagado</option>
          </select>
        </CampoFiltro>

        <button
          type="button"
          onClick={() => setMasFiltros((actual) => !actual)}
          className="flex h-11 items-center justify-center gap-2 rounded-lg border border-slate-300 px-4 text-sm font-semibold text-slate-600 transition hover:bg-slate-100"
        >
          <SlidersHorizontal size={16} />
          Más filtros
          {masFiltros ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>
      </div>

      <div className="-mx-1 mt-4 flex gap-2 overflow-x-auto px-1 pb-1">
        {rangosRapidos.map((rango) => (
          <ChipFiltro
            key={rango.etiqueta}
            activo={
              filtros.fechaDesde === rango.desde && filtros.fechaHasta === rango.hasta
            }
            onClick={() => onAplicarRango(rango)}
          >
            {rango.etiqueta}
          </ChipFiltro>
        ))}
      </div>

      {masFiltros && (
        <div className="mt-4 grid grid-cols-1 gap-3 border-t border-slate-100 pt-4 sm:grid-cols-2 lg:grid-cols-4">
          <CampoFiltro label="Cliente">
            <select
              value={filtros.clienteId}
              onChange={(event) => onCambiarFiltro('clienteId', event.target.value)}
              className={estiloInputFiltro}
            >
              <option value="">Todos los clientes</option>
              {clientes.map((cliente) => (
                <option key={cliente.id} value={cliente.id}>
                  {cliente.razon_social}
                </option>
              ))}
            </select>
          </CampoFiltro>

          <CampoFiltro label="Producto">
            <select
              value={filtros.productoId}
              onChange={(event) => onCambiarFiltro('productoId', event.target.value)}
              className={estiloInputFiltro}
            >
              <option value="">Todos los productos</option>
              {productos.map((producto) => (
                <option key={producto.id} value={producto.id}>
                  {producto.codigo} — {producto.nombre}
                </option>
              ))}
            </select>
          </CampoFiltro>

          <CampoFiltro label="Usuario">
            <select
              value={filtros.usuarioId}
              onChange={(event) => onCambiarFiltro('usuarioId', event.target.value)}
              className={estiloInputFiltro}
            >
              <option value="">Todos los usuarios</option>
              {usuarios.map((usuario) => (
                <option key={usuario.id} value={usuario.id}>
                  {usuario.nombre_completo}
                </option>
              ))}
            </select>
          </CampoFiltro>

          <CampoFiltro label="Cajas/Rejillas">
            <select
              value={filtros.tipoEnvaseId}
              onChange={(event) => onCambiarFiltro('tipoEnvaseId', event.target.value)}
              className={estiloInputFiltro}
            >
              <option value="">Todos</option>
              {tiposEnvase.map((tipo) => (
                <option key={tipo.id} value={tipo.id}>
                  {tipo.codigo} — {tipo.nombre}
                </option>
              ))}
            </select>
          </CampoFiltro>
        </div>
      )}

      {hayFiltrosAvanzadosActivos && (
        <div className="mt-3 flex justify-end border-t border-slate-100 pt-3">
          <button
            type="button"
            onClick={onLimpiar}
            className="text-sm font-semibold text-slate-500 hover:text-red-600"
          >
            Limpiar filtros
          </button>
        </div>
      )}
    </div>
  )
}

export default AnaliticaFiltros
